<template>
  <div id="platformDirectModal" ref="modal" class="modal fade">
    <div class="modal-dialog modal-dialog-top">
      <div class="modal-content rounded overflow-hidden min-w-md-560x">
        <div class="modal-body p-0 overflow-x-hidden">
          <div class="d-flex flex-column">
            <div class="row bg-green-01 mb-2">
              <div class="d-flex justify-content-end pt-2 ms-3 position-absolute">
                <button role="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div
                class="d-flex justify-content-center align-items-center mw-sm-90pct ps-sm-4r py-3"
              >
                <img
                  src="@/assets/images/building-1.png"
                  alt="image"
                  class="img-fluid"
                  style="max-width: 60px"
                />
                <h6 class="fw-bold text-info mb-0 ms-2 me-3">
                  求人掲載企業と直接やり取りをしてみませんか？
                </h6>
              </div>
            </div>

            <div class="text-start px-3 px-md-4 py-3 color-black-02">
              <div class="px-2">
                <p>
                  「社内SE転職ナビ　ダイレクト」をご利用いただくと、求人を掲載する企業と直接メッセージのやり取り、求人応募が可能です。
                </p>
                <p>
                  エージェントサービスと並行してサービスをご利用することができますので、ぜひご利用ください。
                </p>
                <p>ぜひこの機会にご自身のプロフィール情報を充実させてください。</p>
                <p>プロフィール情報をもとに、企業からのスカウトが届くかもしれません。</p>
                <p>
                  ご利用される場合は
                  <a href="/terms" target="_blank">利用規約</a>
                  をご確認・ご同意の上、利用開始してください。
                </p>
              </div>
            </div>

            <div class="d-flex justify-content-center pb-5">
              <a
                class="btn btn-primary rounded px-4 py-2 text-white size-13"
                :href="redirectToServiceDirect()"
              >
                規約に同意してダイレクトサービスを利用する
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { SEARCH_PATH, WELCOME_GUIDE_PATH } from '@/constant/routers/path';

const redirectToServiceDirect = (): string => {
  const redirectUrl = `${SEARCH_PATH}&welcome_popup=true`;
  return `${WELCOME_GUIDE_PATH}?redirect_to=${encodeURIComponent(redirectUrl)}`;
};
</script>
